import { cn } from '@/utils/styles';
import { Link } from '@design-system/Link';
import { Image } from '@design-system/Image';
import { Button } from '@design-system/Button';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { BIOTICS, GEL, LOZENGES, SUPPLEMENTS } from '@/constants/images';
import { SHOP_PATH } from '@/constants/paths';

export interface MyIngredientsPageBannerProps
  extends React.ComponentProps<'button'> {
  productName?: string;
}

const BANNER_IMG_MAP = {
  DEFAULT: GEL,
  'gut': BIOTICS,
  'oral': LOZENGES,
  'supplements': SUPPLEMENTS,
} as Record<string, string>;

export const MyIngredientsPageBanner = ({
  className,
  productName,
}: MyIngredientsPageBannerProps) => {
  const bannerSrc =
    productName && productName in BANNER_IMG_MAP
      ? BANNER_IMG_MAP[productName]
      : BANNER_IMG_MAP.DEFAULT;

  return (
    <Button
      asChild
      data-product={productName}
      className={cn(
        'transition-colors w-full justify-start gap-4 px-4 py-2 min-h-16 border rounded-xl border-stroke-secondary-subtle bg-gradient-to-r data-[product="supplements"]:from-[#F0F0D8] data-[product="supplements"]:to-[#EBFCEE] data-[product="gut"]:from-[#FCF2EB] data-[product="gut"]:to-[#FCF9E3] data-[product="oral"]:from-[#E8EBFC] data-[product="oral"]:to-[#E8F3FC] from-[#E8F8FC] to-[#FAF5EB]',
        className,
      )}
    >
      <Link to={SHOP_PATH}>
        <Image width={40} height={40} aria-hidden src={bannerSrc} />

        <span className="typography-body text-primary">
          All your ingredients in one formula
        </span>

        <ChevronRightIcon
          width={24}
          height={24}
          className="ml-auto !size-6 text-primary"
        />
      </Link>
    </Button>
  );
};
